import type { ChatbotAnswers, Question } from './types';

export const QUESTIONS: readonly Question[] = [
  {
    key: 'age',
    text: '현재 어느 시기를 보내고 계신가요?',
    options: [
      { value: 'Y', label: '청년 (~39세)' },
      { value: 'M', label: '중장년 (40~59세)' },
      { value: 'S', label: '노년 (60세~)' },
    ],
    reactions: {
      Y: '청년을 응원하는 정책 잘 찾아볼게요! 😊',
      M: '중장년층을 위한 필수 정책 잘 찾아볼게요! 😊',
      S: '어르신, 지금 꼭 챙기셔야 하는 정책을 잘 찾아볼게요! 🙏',
    },
  },
  {
    key: 'job',
    text: '현재 어떤 일을 하고 계신가요?',
    options: [
      { value: 'E', label: '직장인·구직·학생' },
      { value: 'B', label: '사업·프리랜서' },
    ],
    reactions: {
      E: '하루하루 바쁘시겠군요. 응원할게요! 💪',
      B: '스스로 길을 만들어가고 계시군요. 멋져요! 😍',
    },
  },
  {
    key: 'hasChild',
    text: '미성년 자녀가 있으신가요?',
    options: [
      { value: 'C', label: '네, 있어요' },
      { value: 'N', label: '아니요, 없어요' },
    ],
    reactions: {
      C: '네, 그럼 육아에 도움드릴 수 있는 정책을 찾아볼게요! 👶',
      N: '알겠습니다! 이어서 찾아볼게요 👀',
    },
  },
  {
    key: 'economic',
    text: '현재 경제적으로 어려움을 겪고 계신가요?',
    options: [
      { value: 'G', label: '아니요, 괜찮아요' },
      { value: 'V', label: '네, 지원이 필요해요' },
    ],
    reactions: {
      G: '다행이네요! 🌿',
      V: '필요한 지원을 찾아드릴게요! 🤝',
    },
  },
];

export const INITIAL_ANSWERS: ChatbotAnswers = {
  age: null,
  job: null,
  hasChild: null,
  economic: null,
};

export const INFO_TEXT =
  '안녕하세요! 맞춤 지원 정책을 찾아드리는\n웰로 정책 매칭봇이에요.';
export const WELCOME_TEXT =
  '질문 4개만 답하면,\n필요한 정책을 바로 추천해드릴게요! 😊';
